const JsVideo = {
	init () {

		/*              __
		               / _)         
		        .-^^^-/ /          
		    __/       /              
		    <__.|_|-|_|  

		    The Emagine Dinosaur says videos should fill the frame while maintaining their aspect ratio, or face the consequences.
		    The Emagine Dinosaur also says; "You may also play videos in a cool little popup modal".            
		*/

		/*
		* Fitvids
		*/

		if ( $('.fitvid').length ) {

			// // http://technology.sapientrazorfish.com/2017/02/18-play-youtube-video-when-preview-image-is-clicked-or-tapped-on-mobile/index.html
			// // https://codepen.io/dennishall/pen/YNmdWp

			// // Load the YouTube IFrame Player API code asynchronously.
			// // https://developers.google.com/youtube/iframe_api_reference
			// var tag = document.createElement('script');
			// tag.src = "https://www.youtube.com/iframe_api";
			// document.body.appendChild(tag);

			// // When the YouTube API code loads, it calls this function, so it must be global
			// // and it must be named exactly onYouTubeIframeAPIReady.
			// window.onYouTubeIframeAPIReady = function () {
			// 	var videoModules = document.querySelectorAll('.video');
			// 	// for Internet Explorer 11 and below, convert array-like NodeList to an actual Array.
			// 	videoModules = Array.prototype.slice.call(videoModules);
			// 	videoModules.forEach(initializeVideoModule);
			// }

			// // Init the videos based on the data-video-id, note there's an exception because we're not using the #player id
			// function initializeVideoModule(videoModule){
			// 	var player = new YT.Player(videoModule.querySelector('.yt-iframe-api-player'), {
			// 		videoId: videoModule.dataset.videoId,
			// 		playerVars: {
			// 			// Uses HTTPS by default, but will block post message locally or anywhere without HTTPS, check the final server
			// 			// Nowadays, most should be using HTTPS
			// 			// host: 'http://www.youtube.com',
			// 			// origin: 'http://localhost:3003',
			// 			html5: 1,
			// 			modestbranding: 0,
			// 			controls: 1,
			// 			rel: 0,
			// 			showinfo: 0
			// 		},
			// 		events: {
			// 			'onReady': onPlayerReady,
			//             'onStateChange': onPlayerStateChange
			// 		}
			// 	});

			// 	function onPlayerReady(event) {
			// 		// console.log("Player Ready");
			// 		// event.target.playVideo();
			// 		// Init fitvids, so the videos display in their correct aspect ratio
			// 		$('.fitvid').fitVids();

			// 		// Catch the iframe, iframe ID, and data id from the ready event
			// 		let ytIframeId = event.target.a.id;
			// 		let ytIframeObj = $('#'+ytIframeId);
			// 		let ytParentDiv = ytIframeObj.parent().closest('.video');
			// 		let targetVideoId = ytParentDiv.data('video-id');

			// 		// ytParentDiv.click( function() {
			// 		// 	console.log($(this));
			// 		// 	$(this).addClass('playing');
			// 		// });

			// 		// If the iframe parent does not have the no-yt-image class override, then we'll source an image for the video.
			// 		if ( !ytParentDiv.hasClass("no-yt-image") ) {

			// 			if (targetVideoId.length == 11) {
			// 				let videoThumbnail = $('<img class="yt-src-img" src="//img.youtube.com/vi/' + targetVideoId + '/0.jpg">');
			// 				// Set background image for video overlay
			// 				ytParentDiv.prepend(videoThumbnail);
			// 			}
			// 		}

			// 		// player.addEventListener('onStateChange', function(e) {
			// 	 //        console.log('State is:', e.data);
			// 	 //    });
			// 	}

			// 	function onPlayerStateChange(event) {

			// 		// -1 (unstarted)
			// 		// 0 (ended) - YT.PlayerState.ENDED
			// 		// 1 (playing) - YT.PlayerState.PLAYING
			// 		// 2 (paused) - YT.PlayerState.PAUSED
			// 		// 3 (buffering) - YT.PlayerState.BUFFERING
			// 		// 5 (video cued) - YT.PlayerState.CUED

			// 		console.log('State is:', event.data);

			// 		var isEnded = event.data === YT.PlayerState.ENDED;
			// 		// 'playing' css class controls fading the video and preivew images in/out.
			// 		// Internet Explorer 11 and below do not support a second argument to `toggle`
			// 		videoModule.classList.toggle('playing', !isEnded);
			// 		// console.log("Video Module ClassList");
			// 		// console.log(videoModule.classList);
			// 		// videoModule.classList[isEnded ? 'remove' : 'add']('playing');
			// 		// if the video is done playing, remove it and re-initialize
			// 		if(isEnded){
			// 			player.destroy();
			// 			videoModule.innerHTML = (
			// 				'<div class="yt-iframe-api-player"></div>'
			// 			);
			// 			initializeVideoModule(videoModule);
			// 		}
			// 	}
			// }

			$('.fitvid').fitVids();
		}

	}
};

export default JsVideo;


// WEBPACK FOOTER //
// ./src/components/03-ui/video/video.js